import GavelRoundedIcon from '@mui/icons-material/GavelRounded';
import ShieldRoundedIcon from '@mui/icons-material/ShieldRounded';
import TextureRoundedIcon from '@mui/icons-material/TextureRounded';
import WavesRoundedIcon from '@mui/icons-material/WavesRounded';
import {
  Box,
  colors,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import Logo from '../../../components/Logo/Logo';

/**
 * A section on the about page that describes the S3G Logo
 */
const LogoMeaning = () => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });
  const iconSize = '2.5em';

  return (
    <Box paddingTop={8} paddingBottom={5}>
      <Grid
        container
        spacing={4}
        data-aos={isMd ? 'fade-right' : 'fade-up'}
        sx={{
          height: '100%',
          marginBottom: '2.5em',
        }}
      >
        <Grid
          item
          md={6}
          sm={12}
          sx={{
            display: 'flex',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <Box
            sx={{
              backgroundColor: 'white',
              width: '100%',
              padding: '1em',
              borderRadius: '1em',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Logo sizeEm={12} theme="light" />
          </Box>
        </Grid>
        <Grid
          item
          md={6}
          sm={12}
          data-aos={isMd ? 'fade-left' : 'fade-up'}
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Box>
            <Typography
              variant="h2"
              align={isMd ? 'left' : 'center'}
              sx={{
                fontWeight: 700,
              }}
            >
              The Meaning Behind Our Logo
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={4} data-aos="fade-up">
        {[
          {
            title: 'Shield',
            subtitle:
              'The shield symbolizes defense, protection, and a safeguard against danger, reflecting our mission to keep people safe.',
            icon: <ShieldRoundedIcon sx={{ fontSize: iconSize }} />,
            color: colors.blue,
          },
          {
            title: 'Line Patterns',
            subtitle:
              'The intricate line patterns represent the many possibilities of movement and courses of action available during crisis situations, emphasizing flexibility and preparedness.',
            icon: <TextureRoundedIcon sx={{ fontSize: iconSize }} />,
            color: colors.common,
          },
          {
            title: 'Blue',
            subtitle:
              'Blue represents calm under pressure, like water that flows fluidly and adapts harmoniously to its environment. It embodies the ability to stay composed during moments of uncertainty.',
            icon: <WavesRoundedIcon sx={{ fontSize: iconSize }} />,
            color: colors.blue,
          },
          {
            title: 'White',
            subtitle:
              'White stands for all that is good and right. It symbolizes clarity, illumination, and insight, aligning with our focus on knowledge and learning to empower others.',
            icon: <GavelRoundedIcon sx={{ fontSize: iconSize }} />,
            color: colors.common,
          },
        ].map((item, i) => (
          <Grid item xs={12} sm={6} md={3} key={i}>
            <Box
              color={
                item.color == colors.common
                  ? item.color
                  : (item.color as any)[
                      theme.palette.mode === 'light' ? 500 : 700
                    ]
              }
            >
              {item.icon}
            </Box>
            <Box
              component={Typography}
              variant={'h6'}
              gutterBottom
              fontWeight={500}
            >
              {item.title}
            </Box>
            <Typography color="text.secondary">{item.subtitle}</Typography>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default LogoMeaning;
